import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { PasswordStrengthValidator } from 'src/app/views/layout/validators/password-strength.validators';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
// import { FileviewerComponent } from '../../modal-popup/fileviewer/fileviewer.component';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { equalValueValidator } from 'src/app/views/layout/validators/equal.validators';
import { Lightbox } from 'ngx-lightbox';
import { RoleType } from 'src/enum/roletype';
import { SecurityService } from 'src/app/services/security.service';

@Component({
  selector: 'app-paccsuserview',
  templateUrl: './paccsuserview.component.html',
  styleUrls: ['./paccsuserview.component.scss']
})
export class PaccsuserviewComponent implements OnInit {

  id = 0;
  actionInfo = 0;
  form: FormGroup;
  routeParams: any;
  pageTitle: string;
  data: any;
  submitbtn: string;
  filesResult: any;
  //selectedImage: any;
  licenceTypeList: any[];
  selectedFileName = 'Choose File';
  dropdownSettings: any = {};
  vehicleList: any = [];
  formEditMode = true;
  Languages: any[];
  RollList: any;
  passworderror = false;
  isReadOnly = false;
  // isDisable: boolean;
  isDisable = false;
  pattern: RegExp;
  show: boolean;
  show2: boolean;
  clientId: any;
  regionList: any[];
  divisionList: any[];
  subdivisionList: any[];
  filterListdivision: any[];
  filterListSubdivision: any[];
  filterregionList: any[];
  filterLanguages: any[];
  filterRollList: any[];
  regionAccess: boolean;
  divisionAccess: boolean;
  subdivisionAccess: boolean;
  images: any[];
  accesstype: any;
  public RoleEnumType = RoleType;
  disabled: boolean = true
  role: number;

  constructor(
    private formBuilder: FormBuilder,
    private _location: Location,
    private overlay: Overlay,
    route: ActivatedRoute,
    public dialog: MatDialog,
    private alertService: AlertService,
    private userSessionService: UserSessionService,
    private userService: UserService,
    private utilityService: UtilityService,
    private translate: TranslateService,
    private regionService: RegionService,
    private divisionService: DivisionService,
    private subdivisionService: SubDivisionService,
    private _lightbox: Lightbox,
    private securityService: SecurityService
  ) {
    this.routeParams = route.snapshot.params;
    const decId = this.securityService.decrypt(this.routeParams.id);
    this.id = decId;
    this.actionInfo = this.routeParams.actionInfo
    if (this.id === 0) {
      this.submitbtn = 'Save';
    } else {
      this.submitbtn = 'Update';
    }
    if (this.actionInfo == 1) {
      this.formEditMode = false
    }
    this.pattern = /^[^\s]+(\s+[^\s]+)*$/;


  }

  ngOnInit(): void {
    this.initializeValidators();
    this.getLanguage();
    this.getVehicleList(true);
    this.getRoll(true);
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'vehicleId',
      textField: 'regNo',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
    this.get(true);
    this.getLookupRegion(true);
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      id: [this.id, Validators.required],
      firstName: [null, [Validators.required]],
      lastName: [null],
      email: [null, [Validators.required, Validators.email]],
      userName: ['', [Validators.required]],
      password: [null, [Validators.required, PasswordStrengthValidator]],
      confirmPassword: [null, [Validators.required]],
      mobileNo: [null, [Validators.required]],
      languageType: ['', [Validators.required]],
      roleId: ['', [Validators.required]],
      userPhoto: [null],
      userPhotoPath: [null],
      themeId: [1],
      isSystemPassword: [false],
      regionId: [null],
      divisionId: [null],
      subDivisionId: [null],
      isProfile: [false],
      ensureid: [null, Validators.required],
    },
      { validator: equalValueValidator('password', 'confirmPassword') }
    );
  }

  onSearchChange(searchValue: any): void {
    this.form.controls['userName'].setValue(searchValue.target.value);
  }

  //  passwordMatchValidator(g: FormGroup) {
  //     return g.get('password').value === g.get('confirmPassword').value
  //        ? null : {'mismatch': true};
  //  }
  get(refresh: boolean) {
    if (this.id > 0) {
      this.userService.getById(this.id, refresh).subscribe(result => {
        this.data = result;
        if (this.data) {
          this.filesResult = this.data.userPhoto;
          // this.selectedImage = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,'
          //   + this.filesResult);
          this.selectedFileName = this.data.userPhotoPath;
          this.form.patchValue(this.data);
          this.getLookupDivision(this.data.regionId);
          this.getLookupSubDivision(this.data.divisionId);
          this.form.controls['ensureid'].setValue(this.data.ensureID);

          this.form.controls['confirmPassword'].setValue('Xx@12345');
          this.form.controls['password'].setValue('Xx@12345');
          this.roleChange();
          // this.form.controls['languageType'].setValue(1);
          if (this.formEditMode === false) {
            this.isReadOnly = false;
            this.form.disable();
            this.isDisable = true;
            // this.isReadOnly = false;
          }
        }
      });
      this.isReadOnly = true;
    }
  }




  getLookupRegion(refresh: boolean) {
    this.regionService.getLookUp(refresh).subscribe(result => {
      if (result) {
        this.regionList = [];
        this.filterregionList = [];
        this.regionList = result;
        this.filterregionList = this.regionList.slice();
      }
    })
  }
  regionChange() {
    this.getLookupDivision(this.form.value.regionId);
    // this.form.controls['divisionId'].setValue(0);
    // this.form.controls['subDivisionId'].setValue(0);
    if (this.form.value.divisionId)
      this.form.controls['divisionId'].setValue(null);
    if (this.form.value.subDivisionId)
      this.form.controls['subDivisionId'].setValue(null);
  }

  getLookupDivision(id) {
    this.divisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.divisionList = [];
        this.filterListdivision = [];
        this.divisionList = result;
        this.filterListdivision = this.divisionList.slice();
      }
    })
  }
  divisionChange() {
    this.getLookupSubDivision(this.form.value.divisionId);
    //  this.form.controls['subDivisionId'].setValue(0);
    if (this.form.value.subDivisionId)
      this.form.controls['subDivisionId'].setValue(null);
  }
  getLookupSubDivision(id) {
    this.subdivisionService.getLookUpbyId(true, id).subscribe(result => {
      if (result) {
        this.subdivisionList = [];
        this.filterListSubdivision = [];
        this.subdivisionList = result;
        this.filterListSubdivision = this.subdivisionList.slice();
      }
    })
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  getLanguage() {
    this.utilityService.getLanguageTypeLookup(true).subscribe(res => {
      if (res) {
        this.Languages = [];
        this.filterLanguages = [];
        this.Languages = res;
        this.filterLanguages = this.Languages.slice();
      }
    });
  }

  getRoll(refresh: boolean) {
    this.userService.getRoll(true).subscribe(res => {
      if (res) {
        this.RollList = [];
        this.filterRollList = [];
        this.RollList = res;
        this.filterRollList = this.RollList.slice();
      }
    });
  }

  getVehicleList(refresh: boolean) {
    this.utilityService.getVehicleLookup(refresh).subscribe(result => {
      this.vehicleList = result.map((data) => ({
        vehicleId: data.key,
        regNo: data.value
      }));
    });
  }

  onFileSelected(event1) {
    const file = event1.target.files[0];
    if (file) {
      this.accesstype = file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')
      if (this.accesstype) {
        this.selectedFileName = file.name;
        let filesize = file.size;
        let acceptsize = parseInt((filesize / 1024).toFixed(2));
        if (acceptsize < 1000) {
          if (event1.target.files && event1.target.files[0]) {
            const reader = new FileReader();
            reader.readAsDataURL(event1.target.files[0]);
            reader.onload = (event: any) => {
              this.filesResult = event.target.result.split(',')[1];
              if (this.filesResult) {
                // this.selectedImage = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,'
                // + this.filesResult);
                this.form.controls['userPhoto'].setValue(this.filesResult);
                this.form.controls['userPhotoPath'].setValue(this.filesResult ? this.selectedFileName : ''); // <-- Set Value for Validation
              }
              // const dialogRef = this.dialog.open(FileviewerComponent, {
              //   scrollStrategy: this.overlay.scrollStrategies.noop(),
              //   disableClose: true,
              //   width: '80%',
              //   data: {
              //     message: this.filesResult,
              //     buttonText: {
              //       cancel: 'Done'
              //     }
              //   }
              // });
            }
          }
        } else {
          this.alertService.error('File size is large');
          this.selectedFileName = '';
        }
      }

    } else {
      this.alertService.error('Please upload JPG, Jpeg & PNG images');
    }
  }




  setvalidator() {
    if (this.regionAccess) {
      if (this.form.value.regionId === null || this.form.value.regionId === 0) {
        this.form.controls['regionId'].setValue(null);
        this.form.controls["regionId"].setValidators(Validators.required);
        this.form.controls["regionId"].updateValueAndValidity();
      }
    } else {
      this.form.controls['regionId'].setValue(0);
    }

    if (this.divisionAccess) {
      if (this.form.value.divisionId === null || this.form.value.divisionId === 0) {
        this.form.controls['divisionId'].setValue(null);
        this.form.controls["divisionId"].setValidators(Validators.required);
        this.form.controls["divisionId"].updateValueAndValidity();
      }
    } else {
      this.form.controls['divisionId'].setValue(0);
    }


    if (this.subdivisionAccess) {
      if (this.form.value.subDivisionId === null || this.form.value.subDivisionId === 0) {
        this.form.controls['subDivisionId'].setValue(null);
        this.form.controls["subDivisionId"].setValidators(Validators.required);
        this.form.controls["subDivisionId"].updateValueAndValidity();
      }
    } else {
      this.form.controls['subDivisionId'].setValue(0);
    }
  }

  onSubmit() {
    this.show = false;
    this.show2 = false;
    this.setvalidator();
    if (this.form.valid) {
      {
        this.userService.savePACCS(this.form.value).subscribe(result => {
          // this.alertService.result(result, true, 'User updated successfully');
          if (result.isSuccess) {
            const msg1 = this.translate.instant('Savedsuccessfully');
            const msg2 = this.translate.instant('Updatedsuccessfully');
            const msg3 = this.translate.instant('User');
            const sucessmsg = this.id == 0 ? msg1 : msg2;
            this.alertService.result(result, true, msg3 + ' ' + sucessmsg);
          }
          else {
            this.alertService.error(result.htmlFormattedFailures)
          }
        });
      }
    } else {
      this.validateFormControl();
    }
  }

  onCancel() {
    this._location.back();
  }
  password() {
    this.show = !this.show;
  }
  confirmpassword() {
    this.show2 = !this.show2;
  }

  roleChange() {
    if (this.form.value.roleId === this.RoleEnumType.SuperintendEngineer) {
      this.regionAccess = true;
      this.divisionAccess = false;
      this.subdivisionAccess = false;
      this.form.controls["regionId"].setValidators(Validators.required);
      this.form.controls["regionId"].updateValueAndValidity();
      this.form.controls["divisionId"].clearValidators();
      this.form.controls["divisionId"].updateValueAndValidity();
      this.form.controls["subDivisionId"].clearValidators();
      this.form.controls["subDivisionId"].updateValueAndValidity();
    } else if (this.form.value.roleId === this.RoleEnumType.ExecutiveEngineer) {
      this.divisionAccess = true;
      this.regionAccess = true;
      this.subdivisionAccess = false;
      this.form.controls["regionId"].setValidators(Validators.required);
      this.form.controls["regionId"].updateValueAndValidity();
      this.form.controls["divisionId"].setValidators(Validators.required);
      this.form.controls["divisionId"].updateValueAndValidity();
      this.form.controls["subDivisionId"].clearValidators();
      this.form.controls["subDivisionId"].updateValueAndValidity();
    } else if (this.form.value.roleId === this.RoleEnumType.AssistantExecutiveEngineer
      || this.form.value.roleId === this.RoleEnumType.AssistantEngineer || this.form.value.roleId === this.RoleEnumType.Foreman
      || this.form.value.roleId === this.RoleEnumType.WSAE || this.form.value.roleId === this.RoleEnumType.WSAEE) {
      this.divisionAccess = true;
      this.regionAccess = true;
      this.subdivisionAccess = true;
      this.form.controls["regionId"].setValidators(Validators.required);
      this.form.controls["regionId"].updateValueAndValidity();
      this.form.controls["divisionId"].setValidators(Validators.required);
      this.form.controls["divisionId"].updateValueAndValidity();
      this.form.controls["subDivisionId"].setValidators(Validators.required);
      this.form.controls["subDivisionId"].updateValueAndValidity();
    } else if (this.form.value.roleId === this.RoleEnumType.ChiefEngineer || this.form.value.roleId === this.RoleEnumType.SeniorEngineer
      || this.form.value.roleId === this.RoleEnumType.Root || this.form.value.roleId === this.RoleEnumType.SuperAdmin) {
      this.divisionAccess = false;
      this.regionAccess = false;
      this.subdivisionAccess = false;
      this.form.controls["regionId"].clearValidators();
      this.form.controls["regionId"].updateValueAndValidity();
      this.form.controls["divisionId"].clearValidators();
      this.form.controls["divisionId"].updateValueAndValidity();
      this.form.controls["subDivisionId"].clearValidators();
      this.form.controls["subDivisionId"].updateValueAndValidity();
    }
  }

  open() {
    this.images = [];
    this.images.push(
      {
        src: 'data:image/jpg;base64,' + this.filesResult,
        caption: 'image',
        thumb: 'data:image/jpg;base64,' + this.filesResult
      });

    this._lightbox.open(this.images, 0, { centerVertically: true });

  }
  onRefresh() {
    this.get(true);

  }

}
